// actions/employee-onboarding/direct.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function directHasErrored(bool) {
  return {
    type: 'ONBOARDING_DIRECT_HAS_ERRORED',
    hasErrored: bool
  };
}

export function directIsLoading(bool) {
  return {
    type: 'ONBOARDING_DIRECT_IS_LOADING',
    isLoading: bool
  };
}

export function directFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_DIRECT_FETCH_DATA_SUCCESS',
    data
  };
}

export function directFetchData(host, params) {
  return (dispatch) => {
    dispatch(directIsLoading(true));
    dispatch(directHasErrored(false));
    fetch(host + 'admin/direct', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(directFetchDataSuccess(result));
            dispatch(directHasErrored(false));
            dispatch(directIsLoading(false));
            PubSub.publish('employee.add.action', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(directHasErrored(true));
            dispatch(directIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(directHasErrored(true));
      dispatch(directIsLoading(false));
    });
  };
}